import { trackNavigationClick } from '@theme/gtm-events';

/**
 * Derives nav_category / nav_subcategory from the DOM hierarchy of the
 * clicked link. Works without modifying every Liquid menu template.
 *
 * Hierarchy for header mega-menu:
 *   [data-gtm-nav="header"]
 *     .mega-menu__link--parent   ← nav_category (top-level)
 *       .mega-menu__link         ← nav_subcategory (column header)
 *         .mega-menu__link       ← nav_element (leaf link)
 *
 * Header top bar links (no mega-menu) — nav_category = link text, others ''.
 * Footer links — nav_type = "footer", nav_category from section heading.
 */

document.addEventListener('click', (e) => {
  const link = /** @type {Element | null} */ (e.target?.closest?.('a[href], button'));
  if (!link) return;

  const navContainer = link.closest('[data-gtm-nav]');
  if (!navContainer) return;

  const navType = navContainer.dataset.gtmNav; // "header" | "footer"

  // Skip utility actions (search, account, cart icon)
  if (link.closest('.header-actions, .search-action, [data-cart-icon]')) return;

  const navElement     = (link.textContent ?? '').trim();
  const navElementType = link.tagName === 'BUTTON' ? 'Button' : 'Link';

  let navCategory    = '';
  let navSubcategory = '';

  if (navType === 'header') {
    // Mega-menu: walk up to find parent label and column header
    const column = link.closest('.mega-menu__column');
    if (column) {
      // nav_subcategory = column header text (.mega-menu__link--parent inside column)
      const columnHeader = column.querySelector('.mega-menu__link--parent') ?? column.querySelector('.mega-menu__link');
      navSubcategory = (columnHeader?.textContent ?? '').trim();

      // nav_category = top-level .menu-list__link title that owns this mega-menu
      const topListItem = link.closest('.menu-list__list-item');
      const topLink     = topListItem?.querySelector(':scope > .menu-list__link');
      navCategory = (topLink?.querySelector('.menu-list__link-title')?.textContent ?? topLink?.textContent ?? '').trim();
    } else {
      // Plain top-bar link
      navCategory = navElement;
    }
  } else if (navType === 'footer') {
    // Footer: nav_category from nearest section heading
    const section = link.closest('[data-gtm-nav-section]');
    navCategory = (section?.dataset.gtmNavSection ?? '').trim();
  }

  if (!navElement) return;

  trackNavigationClick(navType, navCategory, navSubcategory, navElement, navElementType);
});
